import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=95fb88e8&scoped=true"
import script from "./videoUpload.vue?vue&type=script&lang=js"
export * from "./videoUpload.vue?vue&type=script&lang=js"
import style0 from "./videoUpload.vue?vue&type=style&index=0&id=95fb88e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fb88e8",
  null
  
)

export default component.exports